import instance from "../root.api";

export const getAuditoriumRequest = (params) =>
    instance
        .get(`/video-categories`, {params})
        .then((response) => ({response}));
